import { styled } from '@mui/system';
import { Skeleton } from '@mui/material';

export const LineChartContainer = styled('div')(({ theme }) => ({
	width: '530px',
	height: '550px',
	fontFamily: 'Inter',
	'@media (max-width: 768px)': {
		width: '350px'
	},
	'@media (max-width: 480px)': {
		width: '300px'
	},
	'@media (max-width: 360px)': {
		marginLeft: -40
	}
}));

export const LegendContainer = styled('div')(({ theme }) => ({
	height: '150px',
	width: '530px',
	marginBottom: '30px',
	'@media (max-width: 768px)': {
		width: '350px'
	},
	'@media (max-width: 480px)': {
		width: '300px'
	},
	'@media (max-width: 360px)': {
		marginLeft: -40
	}
}));

export const HistogramChartContainer = styled('div')(({ theme }) => ({
	width: '520px',
	height: '550px',
	fontFamily: 'Inter',
	'@media (max-width: 768px)': {
		width: '350px',
		height: '450px'
	},
	'@media (max-width: 480px)': {
		width: '250px',
		height: '350px'
	},
	'@media (max-width: 360px)': {
		marginLeft: -25
	}
}));

export const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
	width: 420,
	height: 420,
	'@media (max-width: 768px)': {
		width: '350px'
	},
	'@media (max-width: 480px)': {
		width: '300px'
	},
	'@media (max-width: 360px)': {
		width: '270px'
	}
}));
